import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"

const ThreadsIconSvg = ({
  color = "primary",
  bg = "#f5f9f9",
  iconStyle,
  ...rest
}) => {
  return (
    <Svg
      fill="none"
      height="33"
      viewBox="-6.3 0 28 17.2"
      width="33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="m11.6722 8.34265c-.0751-.03716-.1514-.07293-.2287-.10717-.1346-2.56002-1.48951-4.02564-3.76462-4.04064-.0103-.00006-.02056-.00006-.03086-.00006-1.36081 0-2.49258.59968-3.18917 1.69091l1.25124.88613c.52038-.8151 1.33707-.98887 1.93853-.98887.00694 0 .01392 0 .02079.00007.74911.00493 1.31439.22979 1.68025.66829.26625.31925.44433.76041.5325 1.31717-.66417-.11654-1.38246-.15237-2.15033-.10692-2.16307.12863-3.55366 1.43106-3.46027 3.24084.0474.918.49038 1.7077 1.24729 2.2236.63996.4362 1.46418.6494 2.3208.6012 1.13126-.0641 2.01872-.5097 2.63785-1.3245.4702-.6187.7676-1.4205.8989-2.43089.5391.33589.9387.77789 1.1593 1.30929.3753.9033.3972 2.3876-.776 3.5978-1.0278 1.0601-2.26338 1.5187-4.13062 1.5329-2.07126-.0159-3.63773-.7016-4.6562-2.0383-.95372-1.2517-1.44661-3.0596-1.465-5.3735.01839-2.31396.51128-4.12185 1.465-5.3735 1.01847-1.33667 2.58491-2.02244 4.65618-2.03833 2.08629.01601 3.68004.70509 4.73754 2.0482.5185.65865.9094 1.48695 1.1671 2.45272l1.4663-.40388c-.3124-1.18875-.8039-2.21311-1.4728-3.06265-1.3557-1.721934-3.3384-2.6042649-5.89303-2.62256h-.01023c-2.54945.0182316-4.50995.903919-5.82701 2.63243-1.172 1.53817-1.7765527 3.67842-1.79686643 6.36124l-.00006357.00633.00006357.00633c.02031373 2.68277.62486643 4.82307 1.79686643 6.36127 1.31706 1.7285 3.27756 2.6142 5.82701 2.6324h.01023c2.26661-.0162 3.86433-.6289 5.18043-1.9865 1.722-1.7761 1.6702-4.0023 1.1026-5.369-.4072-.98009-1.1835-1.77611-2.245-2.30185zm-3.91353 3.79865c-.94804.0551-1.93295-.3842-1.98151-1.3252-.036-.6977.48093-1.47616 2.03969-1.5689.17851-.01063.35368-.01583.52576-.01583.56618 0 1.09586.05679 1.57742.16547-.17962 2.31586-1.23317 2.69186-2.16136 2.74446z"
        fill={color}
      />
    </Svg>
  )
}

export default ThreadsIconSvg
